import React, { useEffect, useState } from 'react';
import S from './DetailModal.module.css';

const ReferenceModal = ({ isOpen, onClose, onSuccess }) => {

  const [pwd, setPwd] = useState('');

  useEffect(() => {
    if (isOpen) {
      setPwd('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSuccess(pwd);
    }
  };

  const handleConfirm = () => {
    onSuccess(pwd);
  };

  return (
    <div className={S.refModal} onClick={onClose}>
      <div className={S.refModalDiv} onClick={(e) => e.stopPropagation()}>
        <a className={`${S.refText} ${S.refTextFirst}`} >리더기 제품정보 확인 및 비밀번호 입력 후 <span className='rf-font'>다운로드</span> 하실 수 있습니다.</a>
        <a className={`${S.refText}`} >이 글은 비밀글 입니다.<br/>비밀번호를 입력하여 주시기 바랍니다.</a>
        <input 
          className={S.refInput}
          type="password" 
          value={pwd} 
          onChange={(e) => setPwd(e.target.value)} 
          onKeyPress={handleKeyPress}
          placeholder="비밀번호를 입력하세요." 
        />
        <div className={S.refBtnDiv}>
          <button className={`${S.refBtn}`} onClick={handleConfirm}>확인</button>
          <button className={`${S.refBtn} ${S.refBtnClose}`} onClick={onClose}>닫기</button>
        </div>
      </div>
    </div>
  );

};

export default ReferenceModal;